export default "__VITE_ASSET__BystD_Jy__"